import { merge } from "lodash";
import setIfNotSet from "@irati/utils/setIfNotSet";
import defaultTenant from "../helpers/defaultTenant";
/** @author: Richard Scoones 24/10/2018
 *  @desc: We have to default some values on the front-end
 */
export default function pargetGet(data, config) {
    var clone = merge({}, defaultTenant, data);
    if (config.useDefaultLocale) {
        clone.locale = defaultTenant.locale;
    }
    setIfNotSet(clone, "settings.color", defaultTenant.settings.color);
    setIfNotSet(clone, "settings.textColor", defaultTenant.settings.textColor);
    setIfNotSet(clone, "settings.imageLink", defaultTenant.settings.imageLink);
    return clone;
}
